/** Kaizen-lifecycle activity types. Merged into ACTIVITY_TYPES.
 *
 * A MEMBER HERE MUST HAVE AN EMITTER. No issue or countermeasure transition is a member, because the leaf is the record
 * and no door writes an activity row, and no agent-spawning RCA/CM cascade event is one (operator directive
 * 2026-08-10) -- a member naming an event nothing can put on the wire is
 * `QUAL-ACTIVITY-TYPE-ZERO-READER-001`'s whole class. The cut set is pinned as `CUT_KAIZEN_LIFECYCLE_MEMBERS` in
 * `const/__tests__/event-catalog-stub-kaizen.test.ts` so the keyset cannot regrow them, and each was verified absent
 * from `migrations/**` in the bare and the SQL-doubled (`''value''`) spelling, so no seeded
 * `metrics.measurement_formula` reads them. Adding any of them means shipping its emitter in the same change (member +
 * EventCatalogKey arm + stub entry, atomically).
 */

export const ACTIVITY_TYPES_KAIZEN = {
	/** The kaizen lifecycle anchor the event catalog pins. It has no emitter (probed 2026-09-24: outside `mission/`, only
	 *  this leaf, the catalog stub, the `EventCatalogKey` union, their pins and one doc name the value), which the header's
	 *  emitter rule forbids -- iss-613352ad owns the cut or the emitter. */
	KAIZEN_OBJECTIVE_CASCADED: 'kaizen_objective_cascaded',
} as const;
